import axios from "axios";

const CreateUser = async (payload) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/create`,
      payload
    );

    if (data?.data !== null) {
      return 200; 
    } else {

      return data?.error?.status || 400; 
    }

  } catch (error) {
    if (error.response) {
      return error.response.status;
    } else {

      return 500;
    }
  }
};

export default CreateUser;
